import * as React from "react";
import styled from "styled-components";
import { Flex } from "../compositeComponents/FlexHelpers";
import { Divider } from "../Divider";
import { tablet } from "../BreakPoints";


type SingleColumnLayoutProps = {
    headerContainer?:React.ReactNode,
    contentContainer:React.ReactNode,
    noDivider?:boolean,
    wide?:boolean
}
export function SingleColumnLayout(props:SingleColumnLayoutProps):JSX.Element
{
    return (
        <Wrapper wide={props.wide}>
            <Flex flexDirection="column" gap={32}>
                <TabWrapper>
                    {props.headerContainer}
                </TabWrapper>
                {props.noDivider !== true && <Divider /> }
                {props.contentContainer}
            </Flex>
        </Wrapper>
    )
}

export function DashboardPageLayout(props:SingleColumnLayoutProps):JSX.Element
{
    return (
        <DashboardPageWrapper>
            <Flex flexDirection="column" gap={32}>
                {props.headerContainer}
                {props.noDivider !== true && <Divider /> }
                {props.contentContainer}
            </Flex>
        </DashboardPageWrapper>
    )
}


const TabWrapper = styled.div`
    width:100%;
    margin: 0 auto;
    max-width: 1020px;
    padding:0px;
`;

const Wrapper = styled.div<{wide?:boolean}>`
    width:100%;
    margin: 32px auto 10px auto;
    max-width: ${props => props.wide ? '90%' : '1020px'};
    padding:0px 10px;
`;

const DashboardPageWrapper = styled.div`
    width:100%;
    margin: 32px auto 0px auto;
    max-width: 90%;
    padding:0px 10px;

    @media(max-width: ${tablet}px){
        max-width: 100%;
    }

`;